import { NOTIFICATION_ALERT, NOTIFICATION_SUCCESS, NOTIFICATION_FAILURE } from './const';

/**
 * notify user of a neutral message
 * @param {string} message - notification
 * @returns {object} action object
 */
export const notifyAlert = message => ({
  type: NOTIFICATION_ALERT,
  message,
  date: Date.now()
});

/**
 * notify user of a failure message
 * @param {string} message - notification
 * @returns {object} action object
 */
export const notifyFailure = message => ({
  type: NOTIFICATION_FAILURE,
  message,
  date: Date.now()
});

/**
 * notify user of a success message
 * @param {string} message - notification
 * @returns {object} action object
 */
export const notifySuccess = message => ({
  type: NOTIFICATION_SUCCESS,
  message,
  date: Date.now()
});
